<template>
  <div class="tw-flex tw-flex-wrap tw-items-center tw-gap-2">
    <ComplianceStatusCell
      :data-test="`compliance-status-${index}`"
      :completed="comp?.completed"
      :status="status"
    />
    <WdsLabel v-if="hireChecksOutstanding" xs subtle warning data-test="compliance-hire-checks-outstanding">
      {{ $t('Hire checks outstanding') }}
    </WdsLabel>
  </div>
</template>

<script lang="ts" setup>
import { computed } from 'vue'
import { WdsLabel } from '@worksome/wds-components'
import { FragmentType, graphql, useFragment } from '@/gql'
import { $t } from '@/app-bootstrapping/SetUpInternationalization'
import ComplianceStatusCell from '@/components/GraphqlDataTable/columns/Compliance/ComplianceStatusCell.vue'
import { complianceStatus } from '@/components/GraphqlDataTable/columns/Compliance/verifiedComplianceData'

const ComplianceStatusColumn = graphql(`
  fragment ComplianceStatusColumn on TrustedContact {
    id
    worker {
      id
      draftHiresWithChecksOutstanding: hires(
        companies: $accounts
        status: DRAFT
        checklistStatus: [BLOCKED]
        first: 1
      ) {
        paginatorInfo {
          total
        }
      }
    }
    verifiedCompliance: compliances(names: [VERIFIED_WORKER_COMPLIANCE], cached: true) {
      name
      completed
      data {
        ...VerifiedComplianceStatus
      }
    }
  }
`)

const props = defineProps<{
  row: FragmentType<typeof ComplianceStatusColumn>
  index: number
}>()

const column = computed(() => useFragment(ComplianceStatusColumn, props.row))
const comp = computed(() => column.value.verifiedCompliance?.[0])
const hireChecksOutstanding = computed(
  () => (column.value.worker.draftHiresWithChecksOutstanding.paginatorInfo.total ?? 0) > 0,
)
const status = computed(() => complianceStatus(comp.value?.data))
</script>
